module.exports = __webpack_public_path__ + "assets/images/ert_3.39c41364ec336f6493b08ccb6121f21f.png";